
import React, { useState, useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getAlerts } from 'data/Querys';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getSportCodeObject } from "components/common/SportCode";
import { useGetEventUnits } from "helpers/commonCodes"
import SvgMirs from 'components/presentation/SvgMirs';

function TickerScroll() {
    const ref = useRef(null);
    const { mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const [msg, setMsg] = useState("");
    const [dataSportCodes, setDataSportCodes] = useState()
    const queryClient = useQueryClient();


    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['messages_alerts', mirs_competition, mirs_discipline, "RESULTS"],
            queryFn: getAlerts,
            refetchInterval: 60000,
            enabled: !mirs_discipline || mirs_discipline && mirs_discipline.length > 3 ? false : true
        }
    );

    const allEventName = useGetEventUnits({ mirs_competition: mirs_competition, mirs_discipline: mirs_discipline, mirs_language: mirs_language })


    useEffect(() => {
        setMsg('')
    }, [mirs_discipline])

    useEffect(() => {
        if (!msg) {
            dataTicker()
        }
    }, [data]);

    useEffect(() => {
        // window.scrollTo(0, 0)
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])





    function updateTicker(ev) {
        if (ev.animationName === 'ticker') {
            dataTicker()
        }
    }

    function dataTicker() {
        data?.alert && data?.alert.sort((a, b) => parseInt(b.alertId) - parseInt(a.alertId));

        //sortDataByField(data, "sort", false)
        //get newer element 
        //const disc = dataDisciplines?.disciplines?.find(e => e.code === mirs_discipline)?.description
        const alertElement = data?.alert?.find(x => x !== undefined)
        const eventName = allEventName?.eventUnits?.find(item => item?.code === alertElement?.alertRsc && item !== undefined)?.description

        let tickerMessage = ''
        if (alertElement?.alertCode && alertElement?.alertCode !== 'OTHR') {
            tickerMessage = (eventName ? (eventName + ' - ') : '') + getSportCodeObject(dataSportCodes, mirs_discipline, '@Alert', alertElement?.alertCode)?.description
        } else if (alertElement !== undefined) {
            tickerMessage = (eventName ? (eventName + ' - ') : '') + alertElement?.message
        }
        setMsg(tickerMessage)
    }

    if (isError || isLoading) { return (''); }

    if (msg) {
        return (
            <>
                <div className="container">
                    <div className="mirs-ticker">
                        <div className="ticker-icon"><SvgMirs className='mirsIcon' code='warning' /></div>
                        <div className={`ticker-wrap  ${msg ? "" : "invisible "}`} >
                            <div className={`${msg ? "ticker" : ""}`} onAnimationIteration={(ev) => {
                                ev.preventDefault();
                                updateTicker(ev);
                            }}>
                                <div className='ticker__item'>
                                    {msg}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    } else {
        return ('');
    }



}




function Ticker() {
    const { mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const [dataSportCodes, setDataSportCodes] = useState()
    const queryClient = useQueryClient();

    //Read Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['messages_alerts', mirs_competition, mirs_discipline, "RESULTS"],
            queryFn: getAlerts,
            refetchInterval: 60000,
            enabled: !mirs_discipline || mirs_discipline && mirs_discipline.length > 3 ? false : true
        }
    );

    const allEventName = useGetEventUnits({ mirs_competition: mirs_competition, mirs_discipline: mirs_discipline, mirs_language: mirs_language })


    useEffect(() => {
        // window.scrollTo(0, 0)
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])


    if (isError || isLoading) { return (''); }


    data?.alert && data?.alert.sort((a, b) => parseInt(b.alertId) - parseInt(a.alertId));

    //sortDataByField(data, "sort", false)
    const alertElement = data?.alert?.find((x) => x !== undefined)

    const eventName = allEventName?.eventUnits?.find(item => item?.code === alertElement?.alertRsc && item !== undefined)?.description
    let tickerMessage = ''
    if (alertElement?.alertCode && alertElement?.alertCode !== 'OTHR') {
        tickerMessage = (eventName ? (eventName + ' - ') : '') + getSportCodeObject(dataSportCodes, mirs_discipline, '@Alert', alertElement?.alertCode)?.description
    } else if (alertElement !== undefined) {
        tickerMessage = (eventName ? (eventName + ' - ') : '') + alertElement?.message
    }


    if (tickerMessage) {
        return (
            <>
                <div className="container">
                    <div className="mirs-ticker">
                        <div className="ticker-icon"><SvgMirs className='mirsIcon' code='warning' /></div>
                        <div role="alert">
                            {tickerMessage}
                        </div>
                    </div>
                </div>
            </>
        )
    } else {
        return ('');
    }



}



export default Ticker;









